import { render, staticRenderFns } from "./xuandong.vue?vue&type=template&id=e954bd72&scoped=true&"
import script from "./xuandong.vue?vue&type=script&lang=js&"
export * from "./xuandong.vue?vue&type=script&lang=js&"
import style0 from "./xuandong.vue?vue&type=style&index=0&id=e954bd72&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e954bd72",
  null
  
)

export default component.exports